import Tag from '../reusable/Tag';

interface StudentVoiceStatusProps {
  status: string | null;
  size?: 'small' | 'medium';
  className?: string;
}

export const getStudentVoiceStatusDisplay = (
  status: string | null
): { text: string; type: 'pending' | 'completed' | 'progress' } => {
  switch (status) {
    case 'QUOTE_SELECTION_NOT_AVAILABLE':
      return { text: 'Not available', type: 'pending' };
    case 'QUOTE_SELECTION_NOT_STARTED':
      return { text: 'Not started', type: 'pending' };
    case 'QUOTE_SELECTION_IN_PROGRESS':
      return { text: 'In progress', type: 'progress' };
    case 'QUOTE_SELECTION_COMPLETED':
      return { text: 'Ready for Lead Facilitator review', type: 'progress' };
    case 'QUOTE_SELECTION_FINALIZED':
      return { text: 'Approved', type: 'completed' };
    default:
      return { text: 'Not available', type: 'pending' };
  }
};

const StudentVoiceStatus = ({ status, size = 'small', className }: StudentVoiceStatusProps) => {
  const { text, type } = getStudentVoiceStatusDisplay(status);
  return <Tag type={type} text={text} size={size} className={className} />;
};

export default StudentVoiceStatus;
